import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'aos/dist/aos.css';
import './assets/scss/main.scss';
import AOS from 'aos';
import Header from './components/Header';
import Footer from './components/footer/Footer';
import ScrollToTop from './ScrollToTop';
import { Toaster } from 'react-hot-toast';
// Lazy load components
const Home = lazy(() => import('./pages/home/Home'));
const Rent = lazy(() => import('./pages/rent/Rent'));
const Rewards = lazy(() => import('./pages/rewards/Rewards'));
const Blog = lazy(() => import('./pages/blog/Blog'));
const Faq = lazy(() => import('./pages/faq/Faq'));
const BlogDetail = lazy(() => import('./pages/blog/BlogDetail'));
const ContactUs = lazy(() => import('./pages/contact/ContactUs'));
const TermsOfUse = lazy(() => import('./pages/termsofuse/TermsOfUse'));
const PrivacyPolicy = lazy(() => import('./pages/privacypolicy/PrivacyPolicy'));
const UserAgreement = lazy(() => import('./pages/useragreement/UserAgreement'));
const NotFound = lazy(() => import('./pages/NotFound').then(module => ({ default: module.NotFound })));
function App() {
    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
        });
    }, []);
    return (_jsxs(BrowserRouter, { children: [_jsx(Toaster, { position: "bottom-center", reverseOrder: false }), _jsx(ScrollToTop, {}), _jsxs("div", Object.assign({ className: "app-container" }, { children: [_jsx(Header, {}), _jsx("main", Object.assign({ className: "main-content" }, { children: _jsx(Suspense, Object.assign({ fallback: _jsx("div", Object.assign({ className: "loading-fallback" }, { children: _jsx("div", Object.assign({ className: "spinner-border text-primary", role: "status" }, { children: _jsx("span", { className: "visually-hidden" }) })) })) }, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Home, {}) }), _jsx(Route, { path: "/rent", element: _jsx(Rent, {}) }), _jsx(Route, { path: "/rewards", element: _jsx(Rewards, {}) }), _jsx(Route, { path: "/blog", element: _jsx(Blog, {}) }), _jsx(Route, { path: "/faq", element: _jsx(Faq, {}) }), _jsx(Route, { path: "/contact-us", element: _jsx(ContactUs, {}) }), _jsx(Route, { path: "/blog-detail/:id", element: _jsx(BlogDetail, {}) }), _jsx(Route, { path: "/termsofuse", element: _jsx(TermsOfUse, {}) }), _jsx(Route, { path: "/privacy-policy", element: _jsx(PrivacyPolicy, {}) }), _jsx(Route, { path: "/user-agreement", element: _jsx(UserAgreement, {}) }), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] }) })) })), _jsx(Footer, {})] }))] }));
}
export default App;
